import { Section } from '../styled/Containers.style'
import { ModalBodyContainer } from '../styled/Modal.style'
import { Vspace } from '../styled/Separators.style'
import { PageTitleStandard, TextCtaSub, TextDefault } from '../styled/Text.style'
import breadcrumb_2_trct from './../../assets/img/breadcrumb_2_trct.png'
import { PageActionButton } from '../styled/Button.style'

export interface ExplenationFotoForTractableProps {
    mainCtaClicked: any
    secondaryCtaClicked: any
}

export const ExplenationFotoForTractable = (props: ExplenationFotoForTractableProps) => {
    const { mainCtaClicked, secondaryCtaClicked } = props
    return (
        <ModalBodyContainer className='no-header'>
            <Section>
                <img src={breadcrumb_2_trct}
                    alt="breadcrumb step 2" />
            </Section>

            <Section>
                <PageTitleStandard>Vuoi velocizzare la gestione del tuo sinistro?</PageTitleStandard>
                <Vspace></Vspace>
                <TextDefault centered> Se vuoi velocizzare la gestione, puoi completare ora lo step 2 scattando alcune foto.</TextDefault>
                <Vspace></Vspace>
                <TextDefault centered>In alternativa, puoi saltare direttamente alla compilazione della CAI (step 3).</TextDefault>
            </Section>

            <Vspace qty={0.5}></Vspace>
            <Section>
                <PageActionButton
                    className='light bold-txt'
                    onClick={mainCtaClicked}>scatta foto aggiuntive</PageActionButton>
            </Section>

            <Vspace qty={0.4}></Vspace>
            <Section>
                <TextCtaSub
                    onClick={secondaryCtaClicked}>Procedi senza scattare foto</TextCtaSub>
            </Section>
        </ModalBodyContainer>
    )
}
